<template>
  <div class="main-content main-conent-maxheight main-content-rows page-home home-lw">
    <div class="home-head">
      <div class="title">农作物病虫害自动监测预警平台</div>
      <n-time></n-time>
      <div v-if="!isFullScreen" class="ctrls">
        <i class="el-icon-full-screen" @click="fullScreen"></i>
      </div>
    </div>

    <div class="main-rows">
      <div class="main-col main-left">
        <lamp v-if="!loading" :dev-key="lamp" :sites="sites"></lamp>
      </div>

      <div class="main-col main-body">
        <div class="device-map-wrap" style="height: 100%;">
          <n-map v-if="!loading" :dev-key="lamp" :geo="geoJson" :sites="sites"></n-map>
        </div>
      </div>

      <div class="main-col main-right">
        <mete v-if="!loading" :weather-key="weatherKey"></mete>
      </div>
    </div>

    <side-menu @site-change="siteChange"></side-menu>
  </div>
</template>

<script>
import { getJson, getGeoJson } from '@/service/site'
import NTime from '../components/time'
import NMap from './components/map'
import Lamp from './components/lamp/index'
import Mete from './components/mete/index'
import SideMenu from '../components/SideMenu'

export default {
  components: { NTime, NMap, Lamp, Mete, SideMenu },
  name: 'Home',
  data() {
    return {
      centerType: 'map',
      clone: null,
      isFullScreen: false,
      lamp: '',
      sites: [],
      token: '',
      geoJson: {},
      loading: false,
      site: ''
    }
  },
  computed: {
    weatherKey() {
      return this.sites && this.sites[0] ? this.sites[0].devices.air : ''
    }
  },
  mounted() {
    this.$el.onfullscreenchange = this.exitFullScreen
    this.init()
  },
  methods: {
    async init() {
      let sidebarOpened = this.$store.getters.sidebarOpened
      if (sidebarOpened) {
        this.$store.dispatch('app/toggleSideBar')
      }

      this.loading = true

      const [json, res] = await Promise.all([
        this.getSites()
      ])
      let data = res && res.data ? res.data : {}
      this.sites = json.sites
      this.geoJson = json.geo
      this.address = data.cameras
      this.token = data.token
      this.loading = false
    },
    async getSites() {
      try {
        const [sites, geo = {}] = await Promise.all([
          getJson(this.companyId),
          getGeoJson(this.companyId)
        ])
        return { sites, geo }
      } catch (e) {
        console.log(e)
        return []
      }
    },
    fullScreen() {
      this.$el.requestFullscreen()
    },
    exitFullScreen() {
      this.isFullScreen = !this.isFullScreen
    },
    siteChange(site) {
      this.site = site || {}
      this.lamp = site.devices.lamp
    }
  }
}
</script>

<style lang="scss">
.page-home.home-lw {
  background-image: url('~@/assets/images/dashboard-bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .home-map-btn-group {
    position: absolute;
    top: 8px;
    left: 80px;
    z-index: 100;

    .el-button {
      background-color: rgba(51, 53, 56, 1);
      border: #656565;

      &.is-disabled {
        background-color: rgba(51, 53, 56, 0.7);
        color: #9aa8d4;
      }
    }
  }

  .device-map-wrap {
    position: relative;
    padding-bottom: 40px;
    box-sizing: border-box;
  }

  .home-head {
    height: 80px;
    width: 100%;
    text-align: center;
    background-image: url('~@/assets/images/title-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;

    .title {
      font-size: 32px;
      line-height: 80px;
      text-align: center;
    }

    .time {
      position: absolute;
      right: 20px;
      top: 60px;
    }

    .ctrls {
      position: absolute;
      right: 20px;
      top: 4px;
      font-size: 1.2rem;
      color: rgba(0, 182, 252, 0.6);
      cursor: pointer;
    }
  }

  .main-col {
    margin: 0 20px;

    .home-card:not(:last-child) {
      // margin-bottom: 40px;
    }
  }

  .el-table {
    border: none;
    box-shadow: none;
  }

  .main-rows {
    height: calc(100% - 100px);
    width: 90%;
    display: flex;
    flex-direction: row;
  }

  .main-left,
  .main-right,
  .main-body {
    display: flex;
    flex-direction: column;
  }

  .main-left,
  .main-right {
    // flex: 1;
    width: 25%;
  }

  .main-body {
    flex: 2;
  }

  .device-picker {
    position: absolute;
    top: 8px;
    right: 20px;
    line-height: 24px;

    .el-input__inner {
      background-color: rgba(51, 53, 56, 0.5);
      border-color: #656565;
      color: #f3f1f1;
    }

    &.left {
      left: 20px;
      right: auto;
    }
  }
}

.device-picker__popper {
  background-color: #333538;
  border-color: #656565;

  .el-select-dropdown__item {
    color: #9aa8d4;

    &.selected {
      background-color: #656565;
      color: #fff;
    }

    &.hover {
      background-color: #656565;
    }
  }

  .popper__arrow {
    border-bottom-color: #656565 !important;

    &::after {
      border-bottom-color: #333538 !important;
    }
  }
}
</style>
